import React from "react";
import { useTranslation } from 'react-i18next';
import CONST from "../../config/CONST";

const CloseBtn = (props) => {

    const {
        callback
    } = props;

    const { t } = useTranslation();

    const onClick = () => {
        if(callback && typeof callback === 'function') {
            callback();
        }
        window[CONST.JS_NAMESPACE].close();
    }

    return (
        <div className={`${CONST.CSS_NAMESPACE}CloseBtn`}>
            <button
                title={ t('Close') }
                onClick={onClick}
            >
                <label>{ t('Close') }</label>
                <img
                    src={`${process.env.REACT_APP_BASEURL}/assets/img/icons/close.svg`}
                    alt={t('Close')}
                />
            </button>
        </div>
    );
};

export default CloseBtn;